<template>
  <div class="dashboard">
    <DateContrast
      v-model="date"
    />

    <!-- 全媒体大盘报表 -->
    <Title
      class="dashboard__title" 
      text="全媒体大盘报表"
    />
    <FullMedia :date="date" />

    <!-- TOP汇总 -->
    <Title
      class="dashboard__title" 
      text="TOP汇总"
    />
    <TopSummary :date="date" />

    <!-- TOP -->
    <Title
      class="dashboard__title" 
      text="TOP"
    />
    <Top :date="date" />

    <!-- 按类型查看 -->
    <Title
      class="dashboard__title" 
      text="按类型查看"
    />
    <Type :date="date" />
  </div>
</template>

<script>
import Title from '@/components/Title';
import DateContrast from './components/DateContrast/';
import FullMedia from './FullMedia/';
import TopSummary from './TopSummary/';
import Top from './Top/';
import Type from './Type/';

import shortcuts from '@/config/shortcuts';

export default {
  components: {
    DateContrast,

    Title,
    FullMedia,
    TopSummary,
    Top,
    Type,
  },

  data() {
    return {
      date: [shortcuts.yesterday.data[0], shortcuts.dayBeforeYesterday.data[0]],
    };
  },
};
</script>

<style lang="less" scoped>
.dashboard {
  &__title {
    margin-top: 40px;
  }
}
</style>